module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcvsYwYZ8UA3J58.5714fd0.woff2";